import {Select} from 'antd';
import styled from 'styled-components';

const StyledUserRoleSelectContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

const StyledUserRoleSelect = styled(Select)`
  width: 100%;
  min-width: 145px;
  &.ant-select-single {
    .ant-select-selector {
      padding: 0;
    }
  }

  &.ant-select.ant-select-outlined .ant-select-selector {
    border: none;
  }

  &.ant-select.ant-select-outlined.ant-select-focused:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }
`;


export {
  StyledUserRoleSelectContainer,
  StyledUserRoleSelect,
};
